module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0813.344dea29.jpg";